'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BasinRest = function () {
  function BasinRest($http) {
    (0, _classCallCheck3.default)(this, BasinRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      POLICIES: 'basin/policies/',
      POLICY_DETAIL: 'basin/policies/%1$s/',
      POLICIES_DOWNLOAD_REQUEST: 'basin/policies/export-nonce/',
      POLICIES_DOWNLOAD: 'basin/policies/export/',
      POLICY_LINES_DOWNLOAD: 'basin/policies/export-lines/',
      POLICIES_SET_COLUMNS: 'basin/policies/set-columns/',
      CLIENTS: 'basin/clients/',
      CLIENT_DETAIL: 'basin/clients/%1$s/',
      CLIENTS_DOWNLOAD_REQUEST: 'basin/clients/export-nonce/',
      CLIENTS_DOWNLOAD: 'basin/clients/export/',
      CLIENTS_SET_COLUMNS: 'basin/clients/set-columns/'

    };
  }

  (0, _createClass3.default)(BasinRest, [{
    key: 'flatten',
    value: function flatten(params) {
      var querystring = '';
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
              k = _step$value[0],
              v = _step$value[1];

          if (Array.isArray(v)) {
            v.forEach(function (x) {
              if (querystring !== '') {
                querystring += "&";
              }
              querystring += encodeURIComponent(k) + '=' + encodeURIComponent(x);
            });
          } else {
            if (querystring !== '') {
              querystring += "&";
            }
            querystring += encodeURIComponent(k) + '=' + encodeURIComponent(v);
          }
        };

        for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(params)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return querystring;
    }
  }, {
    key: 'getPolicies',
    value: function getPolicies(params) {
      return this.$http.get(this.PATH.POLICIES + '?' + this.flatten(params));
    }
  }, {
    key: 'getPolicy',
    value: function getPolicy(id) {
      return this.$http.get(this.sprintf(this.PATH.POLICY_DETAIL, id));
    }
  }, {
    key: 'setPoliciesColumns',
    value: function setPoliciesColumns(columns) {
      return this.$http.post(this.PATH.POLICIES_SET_COLUMNS, { columns: columns });
    }
  }, {
    key: 'downloadPolicies',
    value: function downloadPolicies(params) {
      window.open(this.$http.options.root + "/" + this.PATH.POLICIES_DOWNLOAD + "?" + this.flatten(params), "_blank");
    }
  }, {
    key: 'downloadPolicyLines',
    value: function downloadPolicyLines(params) {
      window.open(this.$http.options.root + "/" + this.PATH.POLICY_LINES_DOWNLOAD + "?" + this.flatten(params), "_blank");
    }
  }, {
    key: 'getClients',
    value: function getClients(params) {
      return this.$http.get(this.PATH.CLIENTS + '?' + this.flatten(params));
    }
  }, {
    key: 'getClient',
    value: function getClient(id) {
      return this.$http.get(this.sprintf(this.PATH.CLIENT_DETAIL, id));
    }
  }, {
    key: 'setClientsColumns',
    value: function setClientsColumns(columns) {
      return this.$http.post(this.PATH.CLIENTS_SET_COLUMNS, { columns: columns });
    }
  }, {
    key: 'downloadClients',
    value: function downloadClients(params) {
      window.open(this.$http.options.root + "/" + this.PATH.CLIENTS_DOWNLOAD + "?" + this.flatten(params), "_blank");
    }
  }]);
  return BasinRest;
}();

exports.default = BasinRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/BasinResource.js
// module id = 305
// module chunks = 0